<template>
    <div>
        <label class="typo__label">{{$t('label.grupo_usuario_associacao')}}</label>

        <multiselect 
            v-model="value" 
            :tag-placeholder= "$t('label.seleciona_enter')"
            :placeholder= "$t('label.grupo_usuario_escolha')"
            :selectLabel= "$t('label.seleciona_enter')"
            :deselectLabel= "$t('label.remove_enter')"
            :selectedLabel= "$t('label.selecionado')"
            label="nome" track-by="id" 
            :options="options" 
            :multiple="true" 
            :taggable="true" 
            @tag="addTag"
            @input="$emit('update:setGrupoUsuario', $event)">            
        </multiselect>        
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'

    import { mapGetters, mapState, mapActions } from "vuex";

    export default {
        props: ["cod", "listaGrupoUsuario"],
        components: {
            Multiselect
        },
        data () {
            return {
                value: [ { } ],                
                options: [ { } ], 
            }
        },    
        mounted(){            
                        
        }, 
        methods: {
            
            ...mapActions("grupoUsuarioStore", ["setGrupoUsuario"]), //transformando a Action em uma "função"		

            addTag (newTag) {
                const tag = {
                    name: newTag,
                    code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
                }
                this.options.push(tag)
                this.value.push(tag)
            }
        },
        computed: {
            ...mapState("grupoUsuarioStore", {
			//monitorando mudanças no estado da seção nomeada
			grupoUsuario: "grupoUsuario",
		}),
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>